<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-row>
      <v-col
        style="max-width: 18rem !important"
        v-for="(table, index) in tables"
        :key="index"
        cols="12"
        md="3"
      >
        <sub-menu-card
          :title="table.title"
          :isSelected="table.name == $route.name"
          :itemKey="table.key"
          @click="subMenuClicked(table.name)"
        />
      </v-col>
    </v-row>
    <template>
      <view-data-form v-if="!loading" />
    </template>
  </v-container>
</template>

<script>
import math from '@/mixins/math'
import ViewDataForm from './components/ViewDataForm'
import SubMenuCard from '@/components/cards/SubMenuCard'

export default {
  name: 'ViewDataIndex',
  components: {
    SubMenuCard,
    ViewDataForm,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tables: [
        {
          key: 'fft',
          title: 'V_FFT_VAIDMUO_TEISES',
          name: 'viewDataFft',
        },
        {
          key: 'fate',
          title: 'V_FATE_VAIDMUO_TEISES',
          name: 'viewDataFate',
        },
      ],
    }
  },
  methods: {
    subMenuClicked(route) {
      this.loading = true
      this.$nextTick(() => {
        this.loading = false
        this.$router.push({ name: route })
      })

    },
  },
}
</script>


<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>

